import axios from "../../service/index";
import React, { Component } from "react"
import { Form, Input, Select, Divider, message, Table, Switch, Modal, Button, Tabs, Tooltip } from 'antd'
import "./index.less";
import UploadQiniu from '../../commponents/uploadQiniu/index'
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
const FormItem = Form.Item;
const { Option } = Select;
const { TabPane } = Tabs;

let dragingIndex = -1;
class BodyRow extends React.Component {
  render() {
    const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
    const style = { ...restProps.style, cursor: 'move' };

    let { className } = restProps;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(<tr {...restProps} className={className} style={style} />),
    );
  }
}
const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};
const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    if (dragIndex === hoverIndex) {
      return;
    }
    props.moveRow(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  },
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, connect => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow),
);

class freePunch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchData: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      name: '',
      top: '',
      publish: '',
      subjectId: '',
      freeListData: [],
      optionList: [],
      modelTitel: '新建',
      subjectIcon: '',
      visible: false,
      formVisible: false,
      selectedRowKeys: [],
      TypeNames: '',
      classifyId: '',
      categoryNum: 0,
      limitCategoryNum: 0,
      activityType: '',
      typeData: [],
      movedData: [],
      classifyname: '',
      showMoved: false,
      notChanged: [],
      columns: [{
        title: '资料名称',
        dataIndex: 'name',
        key: 'name',
        ellipsis: true,
        render: (text, record) => (
          <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
        )
      }, {
        title: '学科',
        dataIndex: 'subjectName',
        key: 'subjectName',
        align: 'center'
      }, {
        title: '需要助力人数',
        dataIndex: 'assistancePeople',
        key: 'assistancePeople',
        align: 'center',
      }, {
        title: '已领取人数',
        dataIndex: 'collectNum',
        key: 'collectNum',
        align: 'center'
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        align: 'center',
        width: '150px',
        ellipsis: true,
        render: (text, record) => (
          <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
        )
      }, {
        title: '创建人',
        dataIndex: 'createName',
        key: 'createName',
        align: 'center'
      }, {
        title: '是否置顶',
        dataIndex: 'top',
        key: 'top',
        align: 'center',
        render: (text, record) => {
          return (
            <Switch defaultChecked={text === 1 ? true : false} key={text === 1 ? true : false} onChange={(checked) => {
              let id = record.id
              let arr = this.state.freeListData
              for (let i = 0; i < arr.length; i++) {
                if (id === arr[i].id) {
                  arr[i].top = checked === true ? 1 : 0
                  this.setState({
                    freeListData: arr
                  })
                }
              }
              return (
                Modal.confirm({
                  title: `${checked === true ? '置顶' : '取消置顶'}`,
                  okText: "确定",
                  cancelText: "取消",
                  content: (
                    <div>
                      <p>{checked === true ? '确定要置顶吗？' : '确定要取消置顶吗'}</p>
                    </div>
                  ),
                  onOk: () => {
                    this.isPost(id, checked, 'ok')
                  },
                  onCancel: () => {
                    this.isPost(id, checked, 'cancel')
                  }
                })
              )
            }} />
          )
        }
      }, {
        title: '发布状态',
        dataIndex: 'publish',
        key: 'publish',
        align: 'center',
        render: (text, record) => {
          return (

            <Switch defaultChecked={text === 1 ? true : false} key={text === 1 ? true : false} onChange={(checked) => {
              let id = record.id
              let arr = this.state.freeListData
              for (let i = 0; i < arr.length; i++) {
                if (id === arr[i].id) {
                  arr[i].publish = checked === true ? 1 : 0
                  this.setState({
                    freeListData: arr
                  })
                }
              }
              return (
                Modal.confirm({
                  title: `${checked === true ? '发布活动' : '取消发布'}`,
                  okText: "确定",
                  cancelText: "取消",
                  content: (
                    <div>
                      <p>{checked === true ? '发布后此活动将同步至用户端，请谨慎操作！确定要发布吗？' : '取消发布后用户端将不展示，请谨慎操作！确定要取消发布吗？'}</p>
                    </div>
                  ),
                  onOk: () => {
                    this.isRelease(id, checked, 'ok')
                  },
                  onCancel: () => {
                    this.isRelease(id, checked, 'cancel')
                  }
                })
              )
            }} />
          )
        }
      },
      {
        title: '操作',
        width: '120px',
        render: (record) => <div>
          <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
            this.props.history.push('/newDatum', { id: record.id, activeId: this.state.activityType })
          }}>编辑</span>
          {record.publish===1?'':<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
            Modal.confirm({
              title: '删除操作',
              okText: "确认",
              cancelText: "取消",
              content: (
                <div>
                  <p style={{ whiteSpace: 'nowrap' }}>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
                </div>
              ),
              onOk: () => {
                this.delSwiper(record.id)
              },
            });
          }}>删除</span>}
        </div>
      }],
      selectedAllData: [],
      typeColumns: [
        { title: '分类名称', dataIndex: 'name', key: 'name', align: 'center' },
        {
          title: '分类图标', dataIndex: 'icon', key: 'icon', align: 'center',
          render: (text, record) => <img src={text} alt="" className="icon-sizes" />
        },
        { title: '资料数量', dataIndex: 'materialsNum', key: 'materialsNum', align: 'center' },
        {
          title: '操作',
          align: 'center',
          render: (record) => <div>
            <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
              this.setState({
                classifyId: record.id,
                formVisible: true,
                modelTitel: '编辑',
                classifyname: record.name,
                subjectIcon: {
                  uid: null,
                  type: null,
                  url: record.icon,
                  name: record.name
                },
              })
            }}>编辑</span>
            {record.materialsNum>0?'':<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
              Modal.confirm({
                title: '删除操作',
                okText: "确认",
                cancelText: "取消",
                content: (
                  <div>
                    <p style={{ whiteSpace: 'nowrap' }}>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
                  </div>
                ),
                onOk: () => {
                  this.delicon(record.id)
                },
              });
            }}>删除</span>}
          </div>
        }
      ],
      moveColumns: [
        { title: '分类名称', dataIndex: 'name', key: 'name' }
      ]
    }
  }

  componentDidMount() {
    this.getSubjectList()
    this.getClassifyList()
  }
  components = {
    body: {
      row: DragableBodyRow,
    },
  };
  moveRow = (dragIndex, hoverIndex) => {
    const { typeData } = this.state;
    const dragRow = typeData[dragIndex];
    this.setState(
      update(this.state, {
        typeData: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
        },
      }),
    );

    let oldSort = []
    for (let i = 0; i < this.state.notChanged.length; i++) {
      oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.typeData[i].id })
    }
    axios.post('materialscategory/sort', oldSort).then(res => {
      if (res.data.code === '200') {
        message.success('更新排序成功')
        this.getClassifyList()
      } else {
        message.error(res.data.msg)
      }
      oldSort = []
    })
  };

  getClassifyList() {
    axios.get('/materialscategory/list').then(res => {
      if (res.data.code === '200') {
        let tabIndex = localStorage.getItem('tab') ? localStorage.getItem('tab') : (res.data.data.data[0]?.id).toString()
        this.setState({
          categoryNum: res.data.data.categoryNum,
          typeData: res.data.data.data,
          notChanged: res.data.data.data,
          activityType: tabIndex || '',
          limitCategoryNum: res.data.data.limitCategoryNum
        }, () => {
          if (localStorage.getItem('tab')) {
            localStorage.removeItem('tab')
          }
          this.materialList()
        })
      } else {
        message.error(res.data.msg)
      }
    })
  }
  materialList = () => {
    axios.post('materials/list', {
      name: this.state.name,
      subjectId: this.state.subjectId,
      top: this.state.top,
      pageNum: this.state.searchData.pageNum,
      pageSize: this.state.searchData.pageSize,
      publish: this.state.publish,
      materialsCategoryId: this.state.activityType
    }).then(res => {
      if (res.data.code === '200') {
        this.setState({
          freeListData: res.data.data.list,
          searchData: {
            pageNum: res.data.data.pageNum,
            pageSize: res.data.data.pageSize,
            total: res.data.data.total
          }

        })
      }
    })
  }
  delicon = (id) => {
    axios.get(`/materialscategory/delete/${id}`).then(res => {
      if (res.data.code === '200') {
        this.getClassifyList()
        message.success('删除成功')
      } else {
        message.error(res.data.msg)
      }
    })
  }
  isPost = (id, checked, text) => {
    let url = ''
    if(checked){
      url = `/materials/top/${id}`
    }else{
      url = `/materials/cancelTop/${id}`
    }
    if(text === 'ok'){
      axios.get(url).then(res => {
        if (res.data.code === '200') {
          message.success('操作成功')
          this.materialList()
        } else {
          message.error(res.data.msg)
          this.materialList()
        }
      })
    }else{
      this.materialList()
    }
  }
  isRelease = (id, checked, text) => {
    let url = ''
    if(checked){
      url = `materials/publish/${id}`
    }else{
      url = `materials/cancelPublish/${id}`
    }
    if (text === 'ok') {
      axios.get(url).then(res => {
        if (res.data.code === '200') {
          message.success('操作成功')
          this.materialList()
        } else {
          message.error(res.data.msg)
          this.materialList()
        }
      })
    } else if (text === 'cancel') {
      this.materialList()
    }
  }
  delSwiper(id) {
		axios.get(`materials/delete/${id}`).then( res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.materialList()
			}else {
				message.error(res.data.msg)
			}
		})
	}
  
  showModal() {
    this.getClassifyList()
    this.setState({
      visible: true,
      modelTitel: '新建'
    })
  }
  handleForm() {
    if (this.state.typeData.length <= 0) return message.error('请先创建资料')
    this.props.history.push('/newDatum', { id: '', activeId: this.state.activityType })
  }
  getQiniuUrl = v => {
    this.setState({
      qiuniuUrl: v
    })
  }
  classifyOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let url = this.state.modelTitel === '新建' ? 'materialscategory/add' : '/materialscategory/update'
        axios.post(url, {
          id: this.state.modelTitel === '编辑' ? this.state.classifyId : '',
          name: values.classifyname,
          icon: (values.classifyIcon.url && this.state.modelTitel === '编辑') ? values.classifyIcon.url : this.state.qiuniuUrl + '/' + values.classifyIcon.response.key
        }).then(res => {
          if (res.data.code === '200') {
            message.success(res.data.msg)
            this.props.form.resetFields();
            this.getClassifyList()
            this.setState({ formVisible: false })
          }else{
            message.error(res.data.msg)
          }
        })
      }
    })
  }
  cancelSelect = () => {
    this.setState({
      selectedAllData: [],
    })
  }
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedAllData: selectedRowKeys })
  }
  getSubjectList() {
    axios.get('subjectController/subjects/2').then(res => {
      if (res.data.code === '200') {
        let arr = res.data.data
        this.setState({
          optionList: arr
        })
      }
    })
  }
  movedOk() {
    axios.post('/materials/changeCategory/save', {
      materialsIds: this.state.selectedAllData, toMaterialsCategoryId: this.state.selectedRowKeys[0]
    }).then(res => {
      // console.log(res)
      if (res.data.code === '200') {
        message.success(res.data.msg)
        this.setState({showMoved: false, selectedAllData: [], selectedRowKeys:[]})
        this.materialList()
      }else{
        message.error(res.data.msg)
      }
    })
  }
  handleMoved() {
    this.setState({
      showMoved: true
    }, () => {
      axios.post('materials/changeCategory/info', {materialsIds: this.state.selectedAllData}).then(res => {
        // console.log(res.data.data)
        if(res.data.code === '200'){
          let data = res.data.data
          let TypeNames = data.categorys.filter(v => v.readonly === true)
          
          this.setState({
            TypeNames: TypeNames.name||'',
            movedData: data.categorys,   
            selectedRowKeys: [TypeNames[0].categroyId]         
          })
        }
      })
    })
  }
  changeTypeChecked = (key) => {
    this.setState({ activityType: key, freeListData: [], searchData: { total: 0, pageNum: 1, pageSize: 10 } }, () => {
      this.materialList()
    })
  }
  render() {
    const { searchData, freeListData, columns, modelTitel, visible, name, activityType, subjectIcon, formVisible, typeData, typeColumns, selectedRowKeys, showMoved, movedData, moveColumns } = this.state
    const { getFieldDecorator } = this.props.form
    const pagination = {
      showSizeChanger: true,
      total: searchData.total,
      pageSizeOptions: ['10', '20', '30', '40'],
      showTotal: () => `共 ${searchData.total} 条`,
      onShowSizeChange: (current, pageSize) => {
        let searchData = this.state.searchData
        searchData.pageNum = current
        searchData.pageSize = pageSize
        this.materialList(searchData)
      },
      onChange: (current) => {
        let searchData = this.state.searchData
        searchData.pageNum = current
        this.materialList(searchData)
      },
    }
    const rowSelection = {
      selectedRowKeys: this.state.selectedAllData,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedAllData: selectedRowKeys })
      }
    }
    const singleRowSelection = {
      type: 'radio',
      columnTitle: "选择",
      columnWidth: "60",
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          selectedRowKeys: selectedRowKeys
        })
      },
      fixed: 'right'
    }
    return (
      <div className="datum-square">
        <span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>资料广场管理</span>
        <Divider />
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', lineHeight: '50px' }}>
            <span>资料名称：</span><Input allowClear value={name} style={{ width: '260px', height: '40px', marginRight: '20px' }}
              placeholder="请输入资料名称"
              onChange={(e) => {
                e.persist()
                this.setState({
                  name: e.target.value
                })
              }}
            ></Input>
            <span>学科：</span>
            <Select placeholder="学科" value={this.state.subjectId} allowClear style={{ width: 140, marginRight: '20px' }} onChange={(value) => {
              this.setState({
                subjectId: value
              })
            }}>
              <Option value={""}>全部</Option>
              {this.state.optionList.map(item => {
                return (<Option key={item.subjectId + item.subjectName} value={item.subjectId}>{item.subjectName}</Option>)
              })}
            </Select>
            <span>是否置顶：</span>
            <Select value={this.state.top} style={{ width: "200px", marginRight: '20px' }} onChange={(val) => {
              this.setState({
                top: val
              })
            }} placeholder="请选择" className="zip-width">
              <Option value=''>全部</Option>
              <Option value={1}>已置顶</Option>
              <Option value={0}>未置顶</Option>
            </Select>
            <span>发布状态：</span>
            <Select value={this.state.publish} style={{ width: "200px", marginRight: '20px' }} onChange={(val) => {
              this.setState({
                publish: val
              })
            }} placeholder="请选择" className="zip-width">
              <Option value=''>全部</Option>
              <Option value={1}>已发布</Option>
              <Option value={0}>未发布</Option>
            </Select>
            <Button className='my-button-primary' type='primary' onClick={() => {
              this.materialList()
            }}>搜索</Button>
            <span style={{ marginLeft: '20px' }} className='my-button-txt' onClick={() => {
              this.setState({
                name: '', top: '', publish: '', subjectId: '', searchData: {
                  pageNum: 1,
                  pageSize: 10,
                  total: 0
                }
              }, () => {
                this.materialList()
              })
            }}>重置</span>
          </div>
          <div style={{width: '260px'}}>
            <Button onClick={() => { this.showModal() }}>资料分类管理</Button>
            <Button className='my-button-primary' style={{ marginLeft: '20px' }} disabled={typeData.length <= 0} type='primary' onClick={() => { this.handleForm() }}>新建资料</Button>
          </div>
        </div>
        <Tabs activeKey={activityType} onChange={this.changeTypeChecked}>
          {typeData.map((item, index) => {
            return (<TabPane tab={item.name} key={item.id}></TabPane>)
          })}
        </Tabs>
        <Table
          dataSource={freeListData}
          columns={columns}
          pagination={pagination}
          rowSelection={rowSelection}
          rowKey={record => record.id + ''}
          rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
        />
        {this.state.selectedAllData.length > 0 ?
          <div className="move-btns">
            已选择<span>{this.state.selectedAllData.length||0}</span>个资料
            <Button onClick={this.cancelSelect} className="default-btn">取消</Button>
            <Button className='my-button-primary' type='primary' onClick={() => { this.handleMoved() }}>移动分类</Button>
          </div>
          : ''}
        <Modal
          width={800}
          title='资料分类管理'
          getContainer={false}
          visible={visible}
          maskClosable={false}
          destroyOnClose
          footer={false}
          onCancel={() => {this.setState({visible: false})}}
        >
          <div className="square-list">
            <div className="list-title">
              <p>你共有<span>{this.state.categoryNum}</span>个分类，分类上限为<span>{this.state.limitCategoryNum}</span>个</p>
              <Button type="primary" onClick={() => { if (this.state.typeData.length >= 20) return message.error('资料分类数量已达上限'); this.setState({ formVisible: true, modelTitel: '新建' }) }}>新建分类</Button>
            </div>
            <DndProvider backend={HTML5Backend}>
              <Table
                dataSource={typeData}
                columns={typeColumns}
                pagination={false}
                components={this.components}
                rowKey={record => record.id + ''} croll={{ y: 500 }}
                rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
                onRow={(record, index) => ({
                  index,
                  moveRow: this.moveRow,
                })}
              />
            </DndProvider>
            {/* <img src={previewUrl} style={{width: '100%', height: 'auto'}} alt="" /> */}
          </div>
        </Modal>

        {formVisible ? <Modal
          width={800}
          getContainer={false}
          title={modelTitel + '资料分类'}
          okText="确认"
          cancelText="取消"
          visible={formVisible}
          maskClosable={false}
          destroyOnClose
          onOk={() => { this.classifyOk() }}
          onCancel={() => { this.setState({ formVisible: false }) }}
        >
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 21 }} onSubmit={this.classifyOk}>
            <FormItem label={"分类名称"}>
              {getFieldDecorator('classifyname', {
                initialValue: modelTitel === '编辑' ? this.state.classifyname : '',
                rules: [{ required: true, message: '请输入分类名称!' }, { max: 10, message: '最多输入10个字符' }],
              })(
                <Input allowClear placeholder='请输入分类名称' maxLength={10} />
              )}
            </FormItem>
            <Form.Item label="分类图标">
              {getFieldDecorator('classifyIcon', {
                initialValue: modelTitel === '编辑' ? subjectIcon : '',
                rules: [{ required: true, message: '请上传分类图标!' }],
              })(
                <UploadQiniu getQiniuUrl={this.getQiniuUrl} />
              )}
            </Form.Item>
          </Form>
        </Modal> : ''}
        <Modal width={800} getContainer={false} title='移动分类'
          okText='确定'
          cancelText="取消"
          visible={showMoved}
          maskClosable={false}
          onOk={() => { this.movedOk() }}
          onCancel={() => { this.setState({ showMoved: false }) }}>
          <div className="move-table">
            <p>当前所属分类：<span>{this.state.TypeNames}</span></p>
            <Table
              rowSelection={singleRowSelection}
              dataSource={movedData}
              columns={moveColumns}
              pagination={false}
              rowKey={record => record.categroyId}
              croll={{ y: 500 }}
            />
          </div>
        </Modal>
      </div>
    )
  }
}
export default Form.create()(freePunch)